import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const n = r(
  (l, e) => /* @__PURE__ */ o.jsx(
    a,
    {
      ref: e,
      ...l,
      image: (i) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 32,
          height: 32,
          fill: "none",
          viewBox: "0 0 32 32",
          ...i,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM19.111 20h-6.158v-1.47l3.914-5.397h-3.96v-1.535h6.105v1.476l-3.961 5.39h4.06z",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
n.displayName = "ZincIcon";
export {
  n as ZincIcon,
  n as default
};
//# sourceMappingURL=index.js.map
